const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '20px',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '16px',
    padding: '20px',
    justifyContent: 'space-between',
    minHeight: '150px',
    height: 'auto',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
      minHeight: '130px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '12px',
      minHeight: '120px',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  cardName: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#637381',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px',
    },
  },
  cardNameCourse: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#637381',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  icon: {
    marginTop: '5px',
    color: '#919EAB',
    fontSize: '20px',
    cursor: 'pointer',
    minWidth: '16px',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '18px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
    },
  },
  iconCourse: {
    marginTop: '5px',
    color: '#919EAB',
    fontSize: '16px',
    cursor: 'pointer',
    minWidth: '13px',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '13px',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 'auto',
    gap: theme.spacing(1),
  },
  value: {
    fontSize: '32px',
    fontWeight: '500',
    color: '#002E47',
    [theme.breakpoints.down('sm')]: {
      fontSize: '28px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '24px',
    },
  },
  valueCourse: {
    fontSize: '24px',
    fontWeight: '500',
    color: '#002E47',
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '20px',
    },
  },
  image: {
    width: '28px',
    height: '28px',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      width: '24px',
      height: '24px',
    },
    [theme.breakpoints.down('xs')]: {
      width: '20px',
      height: '20px',
    },
  },
  imageCourse: {
    width: '24px',
    height: '24px',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      width: '20px',
      height: '20px',
    },
    [theme.breakpoints.down('xs')]: {
      width: '18px',
      height: '18px',
    },
  },
  tooltip: {
    fontSize: '13px',
  },
})

export default styles
